
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyCardinalEast as ObiSimplifiedBuoyCardinalEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-cardinal-east.js';
 
 
 

 
 export const ObiSimplifiedBuoyCardinalEast = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-cardinal-east',
   elementClass: ObiSimplifiedBuoyCardinalEastElement,
   events: {
     
   }
  });
 
 